import { Icon, Spinner, Tooltip, useToast } from '@chakra-ui/react';
import React, { useState } from 'react';
import { GrDocumentCsv } from 'react-icons/gr';
import { billingsColumns, subscriptionColumns, toastTypes } from '../constants';
import {
  createCSVString,
  formatDateFromIsoString,
} from '../utils/helperServices';
import { tokenizedAxios } from '../utils/axiosInterceptor';

const CsvDownload = ({ tableName, tableData, userDetailDict }) => {
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();

  // For both tables
  const csvDownload = (tableName, tableData) => {
    const columns =
      tableName === 'subscriptions' ? subscriptionColumns() : billingsColumns();

    const csvString = createCSVString(tableData, columns);
    var downloadLink = document.createElement('a');
    var blob = new Blob(['\ufeff', csvString]);
    var url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = `${tableName}.csv`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  // Get ALL data without limit/skip and then proceed to csvDownload fn
  async function allBillingsCsvDownload() {
    try {
      const partnerId = userDetailDict?.partnerID;
      const locationIds = userDetailDict?.locations
        ?.map(({ ntwkid }) => ntwkid)
        .join(',');

      setIsLoading(true);
      const response = await tokenizedAxios.get(
        `${process.env.REACT_APP_API_URL}/billing/invoices/transactions`,
        {
          params: {
            partnerId,
            locationIds,
            skip: 0,
            limit: 999, // API will fetch all records if value is 999.
            sortDesc: true,
          },
        }
      );

      setIsLoading(false);

      const { data } = response.data._data || {};

      const billings = (data || []).map(t => ({
        ...t,
        amount: `$${t.amount}`,
        dateTime: formatDateFromIsoString(t.createdOn),
      }));

      csvDownload('billings', billings);
    } catch (error) {
      console.error('Error fetching billings');
      toast(error.isSessionExpired ? toastTypes.sessionExpired : toastTypes.dataFetchError);
      return { error: true };
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      {' '}
      {isLoading ? (
        <Spinner size="xs" ml={3} thickness="2px" />
      ) : (
        <Tooltip hasArrow label="Download" placement="top" shouldWrapChildren>
          <Icon
            alignSelf={'center'}
            _hover={{ cursor: 'pointer' }}
            w={6}
            h={6}
            as={GrDocumentCsv}
            ml={3}
            mt={1}
            aria-label="Download CSV"
            onClick={() =>
              tableName === 'billings'
                ? allBillingsCsvDownload()
                : csvDownload(tableName, tableData)
            }
          />
        </Tooltip>
      )}
    </>
  );
};

export default CsvDownload;
